/** Situações dos motivos de perdas */
export interface MotivoPerdaVendaSituacao {
    id: number;
    nome: string;
}

export const motivoPerdaVendaSituacaoAtivo: MotivoPerdaVendaSituacao = {
    id: 1,
    nome: 'Ativo',
};

export const motivoPerdaVendaSituacaoInativo: MotivoPerdaVendaSituacao = {
    id: 2,
    nome: 'Inativo',
};

export const motivosPerdasVendasSituacaoes: MotivoPerdaVendaSituacao[] = [
    motivoPerdaVendaSituacaoAtivo,
    motivoPerdaVendaSituacaoInativo
];

/** Verifica se a situação do motivo de perda é ativo */
export function isMotivoPerdaVendaAtivo(status: number): boolean {
    if (!status) {
        return false;
    }
    return status === motivoPerdaVendaSituacaoAtivo.id;
}

/** Verifica se a situação do motivo de perda é inativo */
export function isMotivoPerdaVendaInativo(status: number): boolean {
    if (!status) {
        return false;
    }
    return status === motivoPerdaVendaSituacaoInativo.id;
}
